export const roundNumber = (num, decimal = 2) => {
   return Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal);
};
